module.exports = __webpack_public_path__ + "static/media/Mike Woods.f05a912c.png";